

import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";

const fetchDeleteSchedule = async (suiteid) => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  const user = JSON.parse(userDetails);

  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=deleteSchedule&companyid=${user.companyid}&suiteid=${suiteid}`,
  );

  return response.data;
};

const useDeleteScheduleMutation = (options = {}) => {
  return useMutation({
    mutationFn: (suiteid) => fetchDeleteSchedule(suiteid),
    ...options,
  });
};

export default useDeleteScheduleMutation;